import { getCountryFlag } from '../utilities/get-country-flag';
/**
 * Blueparrott ecom domains
 * @remarks This configuration should be somewhere in API.
 */
export var blueparrottEcomDomains = [
    {
        code: "AU" /* EcomCountryCode.Australia */,
        url: "https://www.blueparrott.com/en-au/" /* BlueparrottEcomCountryUrl.Australia */,
        name: "Australia" /* EcomCountryName.Australia */,
        flag: getCountryFlag("AU" /* EcomCountryCode.Australia */),
    },
    {
        code: "AT" /* EcomCountryCode.Austria */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Austria" /* EcomCountryName.Austria */,
        flag: getCountryFlag("AT" /* EcomCountryCode.Austria */),
    },
    {
        code: "BE" /* EcomCountryCode.Belgium */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Belgium" /* EcomCountryName.Belgium */,
        flag: getCountryFlag("BE" /* EcomCountryCode.Belgium */),
    },
    {
        code: "CA" /* EcomCountryCode.Canada */,
        url: "https://www.blueparrott.com/en-ca/" /* BlueparrottEcomCountryUrl.Canada */,
        name: "Canada" /* EcomCountryName.Canada */,
        flag: getCountryFlag("CA" /* EcomCountryCode.Canada */),
    },
    {
        code: "BG" /* EcomCountryCode.Bulgaria */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Bulgaria" /* EcomCountryName.Bulgaria */,
        flag: getCountryFlag("BG" /* EcomCountryCode.Bulgaria */),
    },
    {
        code: "HR" /* EcomCountryCode.Croatia */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Croatia" /* EcomCountryName.Croatia */,
        flag: getCountryFlag("HR" /* EcomCountryCode.Croatia */),
    },
    {
        code: "CY" /* EcomCountryCode.Cyprus */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Cyprus" /* EcomCountryName.Cyprus */,
        flag: getCountryFlag("CY" /* EcomCountryCode.Cyprus */),
    },
    {
        code: "CZ" /* EcomCountryCode.CzechRepublic */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Czech Republic" /* EcomCountryName.CzechRepublic */,
        flag: getCountryFlag("CZ" /* EcomCountryCode.CzechRepublic */),
    },
    {
        code: "DK" /* EcomCountryCode.Denmark */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Denmark" /* EcomCountryName.Denmark */,
        flag: getCountryFlag("DK" /* EcomCountryCode.Denmark */),
    },
    {
        code: "EE" /* EcomCountryCode.Estonia */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Estonia" /* EcomCountryName.Estonia */,
        flag: getCountryFlag("EE" /* EcomCountryCode.Estonia */),
    },
    {
        code: "FI" /* EcomCountryCode.Finland */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Finland" /* EcomCountryName.Finland */,
        flag: getCountryFlag("FI" /* EcomCountryCode.Finland */),
    },
    {
        code: "FR" /* EcomCountryCode.France */,
        url: "https://www.blueparrott.com/fr-fr/" /* BlueparrottEcomCountryUrl.France */,
        name: "France" /* EcomCountryName.France */,
        flag: getCountryFlag("FR" /* EcomCountryCode.France */),
    },
    {
        code: "DE" /* EcomCountryCode.Germany */,
        url: "https://www.blueparrott.com/de-de/" /* BlueparrottEcomCountryUrl.Germany */,
        name: "Germany" /* EcomCountryName.Germany */,
        flag: getCountryFlag("DE" /* EcomCountryCode.Germany */),
    },
    {
        code: "GB" /* EcomCountryCode.GreatBritain */,
        url: "https://www.blueparrott.com/en-gb/" /* BlueparrottEcomCountryUrl.GreatBritain */,
        name: "Great Britain" /* EcomCountryName.GreatBritain */,
        flag: getCountryFlag("GB" /* EcomCountryCode.GreatBritain */)
    },
    {
        code: "GR" /* EcomCountryCode.Greece */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Greece" /* EcomCountryName.Greece */,
        flag: getCountryFlag("GR" /* EcomCountryCode.Greece */),
    },
    {
        code: "HU" /* EcomCountryCode.Hungary */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Hungary" /* EcomCountryName.Hungary */,
        flag: getCountryFlag("HU" /* EcomCountryCode.Hungary */),
    },
    {
        code: "IE" /* EcomCountryCode.Ireland */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Ireland" /* EcomCountryName.Ireland */,
        flag: getCountryFlag("IE" /* EcomCountryCode.Ireland */),
    },
    {
        code: "IT" /* EcomCountryCode.Italy */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Italy" /* EcomCountryName.Italy */,
        flag: getCountryFlag("IT" /* EcomCountryCode.Italy */),
    },
    {
        code: "LV" /* EcomCountryCode.Latvia */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Latvia" /* EcomCountryName.Latvia */,
        flag: getCountryFlag("LV" /* EcomCountryCode.Latvia */),
    },
    {
        code: "LT" /* EcomCountryCode.Lithuania */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Lithuania" /* EcomCountryName.Lithuania */,
        flag: getCountryFlag("LT" /* EcomCountryCode.Lithuania */),
    },
    {
        code: "LU" /* EcomCountryCode.Luxembourg */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Luxembourg" /* EcomCountryName.Luxembourg */,
        flag: getCountryFlag("LU" /* EcomCountryCode.Luxembourg */),
    },
    {
        code: "MT" /* EcomCountryCode.Malta */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Malta" /* EcomCountryName.Malta */,
        flag: getCountryFlag("MT" /* EcomCountryCode.Malta */),
    },
    {
        code: "NL" /* EcomCountryCode.Netherlands */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Netherlands" /* EcomCountryName.Netherlands */,
        flag: getCountryFlag("NL" /* EcomCountryCode.Netherlands */),
    },
    {
        code: "NZ" /* EcomCountryCode.NewZealand */,
        url: "https://www.blueparrott.com/en-nz/" /* BlueparrottEcomCountryUrl.NewZealand */,
        name: "New Zealand" /* EcomCountryName.NewZealand */,
        flag: getCountryFlag("NZ" /* EcomCountryCode.NewZealand */),
    },
    {
        code: "PL" /* EcomCountryCode.Poland */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Poland" /* EcomCountryName.Poland */,
        flag: getCountryFlag("PL" /* EcomCountryCode.Poland */),
    },
    {
        code: "PT" /* EcomCountryCode.Portugal */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Portugal" /* EcomCountryName.Portugal */,
        flag: getCountryFlag("PT" /* EcomCountryCode.Portugal */),
    },
    {
        code: "RO" /* EcomCountryCode.Romania */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Romania" /* EcomCountryName.Romania */,
        flag: getCountryFlag("RO" /* EcomCountryCode.Romania */),
    },
    {
        code: "SK" /* EcomCountryCode.Slovakia */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Slovakia" /* EcomCountryName.Slovakia */,
        flag: getCountryFlag("SK" /* EcomCountryCode.Slovakia */),
    },
    {
        code: "SI" /* EcomCountryCode.Slovenia */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Slovenia" /* EcomCountryName.Slovenia */,
        flag: getCountryFlag("SI" /* EcomCountryCode.Slovenia */),
    },
    {
        code: "ES" /* EcomCountryCode.Spain */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Spain" /* EcomCountryName.Spain */,
        flag: getCountryFlag("ES" /* EcomCountryCode.Spain */),
    },
    {
        code: "SE" /* EcomCountryCode.Sweden */,
        url: "https://www.blueparrott.com/en-emea/" /* BlueparrottEcomCountryUrl.Emea */,
        name: "Sweden" /* EcomCountryName.Sweden */,
        flag: getCountryFlag("SE" /* EcomCountryCode.Sweden */),
    },
];
